import firebaseLogger from './firebaseLogger';
import { extractErrorDetails } from './errors';
import { ENV } from '../constants';

interface LogContext {
  [key: string]: any;
}

/** Console + Firebase logger for public app. */
class Logger {
  private isDev = ENV === 'dev';

  /** Logs debug messages (development only) */
  debug(message: string, context?: LogContext): void {
    if (this.isDev) {
      console.debug(`[DEBUG] ${message}`, context);
    }
    try {
      firebaseLogger.debug(message, context);
    } catch {}
  }

  /** Logs informational messages */
  info(message: string, context?: LogContext): void {
    console.info(`[INFO] ${message}`, context);

    try {
      firebaseLogger.info(message, context);
    } catch {}
  }

  /** Logs warning messages */
  warn(message: string, context?: LogContext): void {
    console.warn(`[WARN] ${message}`, context);
    try {
      firebaseLogger.warn(message, context);
    } catch {}
  }

  /** Logs error messages with full error details */
  error(message: string, error?: Error | unknown, context?: LogContext): void {
    const errorDetails = error ? extractErrorDetails(error) : {};
    if (!this.isDev && errorDetails.stack) {
      delete errorDetails.stack;
    }

    console.error(`[ERROR] ${message}`, { error: errorDetails, ...context });

    try {
      firebaseLogger.error(message, error, context);
    } catch {}
  }

}

const logger = new Logger();
export default logger;
